export default __webpack_public_path__ + "assets/images/ad5f021863971fb83cb4b25b8227910c.png";